import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import VueRouter from 'vue-router'
Vue.config.productionTip = false

// const routes = [
//   { path: '/:id', component: App }
// ]
// const router = new VueRouter({
//   routes
// })

Vue.use(VueRouter)
Vue.use(Antd);
new Vue({
  // router,
  render: h => h(App),
}).$mount('#app')
